import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, IconButton, ProgressIndicator, Step, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Flex, } from "@reverb-ui/react";
import { ArrowLeft } from "@reverb-ui/icons-react";
import { CompanyForm } from "@/features/first-access/presentation/containers/company-form";
import { CompanyProfileForm } from "@/features/first-access/presentation/containers/company-profile-form";
import { CompanyAddressForm, } from "@/features/first-access/presentation/containers/company-address-form";
import { CompanyUsersForm } from "@/features/first-access/presentation/containers/company-users-form";
import { CompanyWizardContext } from "@/features/first-access/presentation/context-api/company-wizard-provider";
import UsersTabProvider from "@/features/first-access/presentation/context-api/users-tab-provider";
import { makeEntityDatasource } from "@/main/factories/datasources/entity-datasource-factory";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { useHistory } from "react-router";
var ESteps;
(function (ESteps) {
    ESteps["PROFILE"] = "Profile";
    ESteps["COMPANY"] = "Company";
    ESteps["ADDRESS"] = "Address";
    ESteps["USERS"] = "Users";
    // SECURITY = "Security",
})(ESteps || (ESteps = {}));
export var CompanyFirstAccess = function () {
    var createdCompanyId = useContext(CompanyWizardContext).createdCompanyId;
    var clientWallets = useContext(AuthContext).clientWallets;
    var _a = useState(ESteps.PROFILE), selectedStep = _a[0], setSelectedStep = _a[1];
    var _b = useState([]), addedAddress = _b[0], setAddedAddress = _b[1];
    var _c = useState(null), addressDefaultValues = _c[0], setAddressDefaultValues = _c[1];
    var _d = useState(undefined), locationId = _d[0], setLocationId = _d[1];
    var history = useHistory();
    useEffect(function () {
        if ((clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets.length) && !createdCompanyId) {
            history.replace("/");
        }
    }, [createdCompanyId, clientWallets, history]);
    useEffect(function () {
        if (createdCompanyId || (clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets.length)) {
            setSelectedStep(ESteps.ADDRESS);
        }
    }, [createdCompanyId, clientWallets]);
    useEffect(function () {
        if (addedAddress.length) {
            isStepDone(ESteps.ADDRESS);
            setAddressFormValues();
        }
    }, [addedAddress]);
    var stepsList = useMemo(function () { return Object.values(ESteps); }, []);
    var stepIndex = useMemo(function () { return stepsList.indexOf(selectedStep); }, [selectedStep, stepsList]);
    var hasPreviousStep = useMemo(function () {
        if ((createdCompanyId || (clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets.length)) &&
            (selectedStep === ESteps.COMPANY ||
                selectedStep === ESteps.PROFILE ||
                selectedStep === ESteps.ADDRESS)) {
            return false;
        }
        return stepIndex !== 0;
    }, [stepIndex, selectedStep, createdCompanyId, clientWallets]);
    var hasNextStep = useMemo(function () { return stepIndex + 1 !== stepsList.length; }, [stepIndex, stepsList]);
    var goToNextStep = function () {
        setSelectedStep(stepsList[stepIndex + 1]);
    };
    var goToPrevStep = function () {
        setSelectedStep(stepsList[stepIndex - 1]);
    };
    var isStepDone = function (step) {
        if (createdCompanyId || (clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets.length)) {
            return step === ESteps.PROFILE || step === ESteps.COMPANY;
        }
        if (addedAddress.length) {
            return step === ESteps.ADDRESS;
        }
        return false;
    };
    var setAddressFormValues = function () {
        var address = addedAddress[0];
        var defaultValues = {
            id: address === null || address === void 0 ? void 0 : address.id,
            typeId: {
                value: address === null || address === void 0 ? void 0 : address.type.id,
                label: address === null || address === void 0 ? void 0 : address.type.description,
            },
            cityId: {
                value: address === null || address === void 0 ? void 0 : address.city.id,
                label: address === null || address === void 0 ? void 0 : address.city.description,
            },
            stateId: {
                value: address === null || address === void 0 ? void 0 : address.state.id,
                label: address === null || address === void 0 ? void 0 : address.state.description,
            },
            countryId: {
                value: address === null || address === void 0 ? void 0 : address.country.id,
                label: address === null || address === void 0 ? void 0 : address.country.description,
            },
            addressNumber: address === null || address === void 0 ? void 0 : address.number,
            street: address === null || address === void 0 ? void 0 : address.street,
            neighborhood: address === null || address === void 0 ? void 0 : address.neighborhood,
            zipCode: address === null || address === void 0 ? void 0 : address.zipCode,
            complement: address === null || address === void 0 ? void 0 : address.complement,
        };
        setAddressDefaultValues(defaultValues);
    };
    return (React.createElement(Box, { w: "full" },
        React.createElement(Modal, { isOpen: true, onClose: function () { return null; }, size: "3xl" },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null,
                    React.createElement(IconButton, { variant: "ghost", "aria-label": "Go back", icon: React.createElement(ArrowLeft, { color: "gray.500", size: "lg", variant: "solid" }), onClick: function () { return history.push("/first-access"); }, isDisabled: !!createdCompanyId || !!(clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets.length) })),
                React.createElement(ModalBody, null,
                    React.createElement(Flex, { w: "full", justifyContent: "center" },
                        React.createElement(ProgressIndicator, { mode: "horizontal", colorScheme: "blue" }, stepsList.map(function (step) { return (React.createElement(Step, { key: step, title: step, type: "bullet", done: isStepDone(step), current: selectedStep === step })); }))),
                    React.createElement(Box, { px: 8, pt: 6, w: "full" },
                        selectedStep === ESteps.PROFILE && (React.createElement(CompanyProfileForm, { hasNextStep: hasNextStep, hasPreviousStep: hasPreviousStep, goToNextStep: goToNextStep, goToPrevStep: goToPrevStep })),
                        selectedStep === ESteps.COMPANY && (React.createElement(CompanyForm, { hasNextStep: hasNextStep, hasPreviousStep: hasPreviousStep, goToNextStep: goToNextStep, goToPrevStep: goToPrevStep, setLocationId: setLocationId })),
                        selectedStep === ESteps.ADDRESS && (React.createElement(CompanyAddressForm, { hasNextStep: hasNextStep, hasPreviousStep: hasPreviousStep, goToNextStep: goToNextStep, goToPrevStep: goToPrevStep, setAddedAddress: setAddedAddress, defaultValues: addressDefaultValues })),
                        selectedStep === ESteps.USERS && (React.createElement(UsersTabProvider, { entityRepository: makeEntityDatasource() },
                            React.createElement(CompanyUsersForm, { hasNextStep: hasNextStep, hasPreviousStep: hasPreviousStep, goToNextStep: goToNextStep, goToPrevStep: goToPrevStep, locationId: locationId })))))))));
};
